module.exports = __webpack_public_path__ + "static/media/(V)_MG_4919_-_Pro-Natura_-_Moda_Feminina.c5d2bf29.jpg";